import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import PatientDetailsTabs from "../../Navigation/PatientDetailsTabs";
import DetailsTrend from "./PatientDetailsTrend";

const PatientDetailsPanel = ({ selectedPatientDetails, showPanelDetails, setShowPanelDetails }) => {
    const [activeTab, setActiveTab] = useState("details");
    const handleClosePanel = () => {
        setShowPanelDetails(false);
    };

    if (!selectedPatientDetails || !showPanelDetails) return null;

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return dateStr;
        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const yyyy = date.getFullYear();
        return `${dd}-${mm}-${yyyy}`;
    };

    return (
        <div>
            {/* Overlay */}
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 9998,
                    pointerEvents: "auto",
                }}
                onClick={handleClosePanel}
            />
            {/* Panel */}
            <div
                className="patient-details-panel panel-open"
                style={{
                    position: "fixed",
                    top: 0,
                    right: 0,
                    width: "70vw", // Extra large width
                    maxWidth: "1100px",
                    height: "100vh",
                    backgroundColor: "#fff",
                    boxShadow: "-5px 0px 20px rgba(0, 0, 0, 0.12)",
                    zIndex: 9999,
                    padding: "0",
                    overflowY: "auto",
                    borderTopLeftRadius: "16px",
                    borderBottomLeftRadius: "16px",
                }}
            >
                {/* Header */}
                <div className="panel-header d-flex align-items-center justify-content-between px-4 py-3 border-bottom">
                    <h5 className="mb-0 fw-bold text-primary">
                        Patient Details: <span className="text-dark">{selectedPatientDetails.name} {selectedPatientDetails.surname}</span>
                    </h5>
                    <button
                        className="btn btn-light btn-close p-0 d-flex align-items-center justify-content-center"
                        onClick={handleClosePanel}
                        aria-label="Close"
                        style={{
                            borderRadius: "50%",
                            width: "40px",
                            height: "40px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        }}
                    >
                        <FaTimes className="text-danger" style={{ fontSize: "22px" }} />
                    </button>
                </div>

                {/* Tabs */}
                <div className="px-4 pt-3">
                    <PatientDetailsTabs activeTab={activeTab} handleTabChange={handleTabChange} />
                </div>
                <hr className="my-0" />

                {/* Content */}
                <div className="tab-content px-4 pb-4">
                    {activeTab === "details" && (
                        <div className="tab-pane fade show active">
                            <form>
                                {/* Personal Info */}
                                <section>
                                    <div className="row mb-4">
                                        <div className="col-12 col-md-3 text-center mb-3 mb-md-0 d-flex flex-column align-items-center justify-content-center">
                                            <img
                                                src={selectedPatientDetails.photo || "default-image.jpg"}
                                                alt="Patient"
                                                className="img-fluid rounded-circle border"
                                                style={{ width: "120px", height: "120px", objectFit: "cover", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}
                                            />
                                            <div className="mt-2 fw-semibold text-secondary">{selectedPatientDetails.name} {selectedPatientDetails.surname}</div>
                                        </div>
                                        <div className="col-12 col-md-9">
                                            <div className="row g-3">
                                                <div className="col-12 col-md-6">
                                                    <label className="form-label fw-semibold text-gray">Name</label>
                                                    <input type="text" className="form-control bg-light" value={selectedPatientDetails.name} readOnly />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <label className="form-label fw-semibold text-gray">Surname</label>
                                                    <input type="text" className="form-control bg-light" value={selectedPatientDetails.surname} readOnly />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <label className="form-label fw-semibold text-gray">Email</label>
                                                    <input type="email" className="form-control bg-light" value={selectedPatientDetails.email} readOnly />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <label className="form-label fw-semibold text-gray">Phone Number</label>
                                                    <input type="text" className="form-control bg-light" value={selectedPatientDetails.phone} readOnly />
                                                </div>
                                                <div className="col-12 col-md-3">
                                                    <label className="form-label fw-semibold text-gray">Gender</label>
                                                    <input type="text" className="form-control bg-light" value={selectedPatientDetails.gender} readOnly />
                                                </div>
                                                <div className="col-12 col-md-3">
                                                    <label className="form-label fw-semibold text-gray">Date of Birth</label>
                                                    <input
                                                        type="date"
                                                        className="form-control bg-light"
                                                        value={selectedPatientDetails.dob ? new Date(selectedPatientDetails.dob).toISOString().slice(0, 10) : ""}
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="col-12 col-md-3">
                                                    <label className="form-label fw-semibold text-gray">Language</label>
                                                    <input type="text" className="form-control bg-light" value={selectedPatientDetails.language} readOnly />
                                                </div>
                                                <div className="col-12 col-md-3">
                                                    <label className="form-label fw-semibold text-gray">City</label>
                                                    <input type="text" className="form-control bg-light" value={selectedPatientDetails.city} readOnly />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                {/* Emergency Contact */}
                                <section className="row mb-4">
                                    <div className="col-12 col-md-4">
                                        <label className="form-label fw-semibold text-gray">Emergency Contact Name</label>
                                        <input type="text" className="form-control bg-light" value={selectedPatientDetails.emergencycontactname} readOnly />
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <label className="form-label fw-semibold text-gray">Relation</label>
                                        <input type="text" className="form-control bg-light" value={selectedPatientDetails.emergencycontactrelation} readOnly />
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <label className="form-label fw-semibold text-gray">Emergency Contact Number</label>
                                        <input type="text" className="form-control bg-light" value={selectedPatientDetails.emergencycontact} readOnly />
                                    </div>
                                </section>

                                {/* Insurance */}
                                <section className="row mb-4">
                                    <div className="col-12 col-md-6">
                                        <label className="form-label fw-semibold text-gray">Insurance Company</label>
                                        <input type="text" className="form-control bg-light" value={selectedPatientDetails.insuranceCompany} readOnly />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <label className="form-label fw-semibold text-gray">Policy Number</label>
                                        <input type="text" className="form-control bg-light" value={selectedPatientDetails.insuranceNumber} readOnly />
                                    </div>
                                </section>

                                {/* Other Info */}
                                <section className="row mb-4">
                                    <div className="col-12 col-md-3">
                                        <label className="form-label fw-semibold text-gray">Raze/Ethnicity</label>
                                        <input type="text" className="form-control bg-light" readOnly />
                                    </div>
                                    <div className="col-12 col-md-3">
                                        <label className="form-label fw-semibold text-gray">Marital Status</label>
                                        <input type="text" className="form-control bg-light" readOnly />
                                    </div>
                                    <div className="col-12 col-md-3">
                                        <label className="form-label fw-semibold text-gray">Education Level</label>
                                        <input type="text" className="form-control bg-light" value={selectedPatientDetails.position} readOnly />
                                    </div>
                                    <div className="col-12 col-md-3">
                                        <label className="form-label fw-semibold text-gray">Occupation</label>
                                        <input type="text" className="form-control bg-light" value={selectedPatientDetails.position} readOnly />
                                    </div>
                                </section>

                                {/* Physical & Habits */}
                                <section className="row mb-4">
                                    <div className="col-12 col-md-3">
                                        <label className="form-label fw-semibold text-gray">Height</label>
                                        <input type="number" className="form-control bg-light" value={selectedPatientDetails.height} readOnly />
                                    </div>
                                    <div className="col-12 col-md-3">
                                        <label className="form-label fw-semibold text-gray">Weight</label>
                                        <input type="number" className="form-control bg-light" value={selectedPatientDetails.weight} readOnly />
                                    </div>
                                    <div className="col-12 col-md-6 row">
                                        <label className="form-label fw-semibold text-gray">Habits</label>
                                        <div className="col-12 col-md-4 mt-1">
                                            <label className="form-label">Smoking</label>
                                            <input type="checkbox" className="form-check-input" checked={selectedPatientDetails.isSmoker} readOnly />
                                        </div>
                                        <div className="col-12 col-md-4 mt-1">
                                            <label className="form-label">Alcohol</label>
                                            <input type="checkbox" className="form-check-input" checked={selectedPatientDetails.isAlcoholAddict} readOnly />
                                        </div>
                                        <div className="col-12 col-md-4 mt-1">
                                            <label className="form-label">Drug</label>
                                            <input type="checkbox" className="form-check-input" checked={selectedPatientDetails.isDrugAddict} readOnly />
                                        </div>
                                    </div>
                                </section>

                                {/* Address */}
                                <section className="mb-4">
                                    <label className="form-label fw-semibold text-gray">Address</label>
                                    <input type="text" className="form-control bg-light" value={selectedPatientDetails.address} readOnly />
                                </section>

                                {/* Additional Info */}
                                <section className="mb-4">
                                    <label className="form-label fw-semibold text-gray">About</label>
                                    <textarea className="form-control bg-light" value={selectedPatientDetails.about} readOnly />
                                </section>
                                <section className="mb-4">
                                    <label className="form-label fw-semibold text-gray">Summary</label>
                                    <textarea className="form-control bg-light" value={selectedPatientDetails.summary} readOnly />
                                </section>
                            </form>
                        </div>
                    )}
                    {activeTab === "trends" && (
                        <DetailsTrend />
                    )}
                </div>
            </div>
        </div>
    );
};

export default PatientDetailsPanel;

